import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import PreferredTimesSummarySkeleton from '../components/PreferredTimesSummary/PreferredTimesSummarySkeleton';
import TimeslotPickerSkeleton from '../components/ServiceRequestTimeslotPicker/TimeslotPickerSkeleton';
import './service-request-scheduling.scss';

const SchedulingBodySkeleton = () => {
  return (
    <>
      <PreferredTimesSummarySkeleton />
      <div className="preferred-appointment-times">
        <Skeleton variant="text" width="28rem" height={26} />
        <div className="scheduling-calendar-box">
          <TimeslotPickerSkeleton />
        </div>
      </div>
    </>
  );
};

export default SchedulingBodySkeleton;
